// © Microsoft Corporation. All rights reserved.
import React from 'react';
import { PrimaryButton, Stack } from '@fluentui/react';
import { VideoCameraEmphasisIcon } from '@fluentui/react-icons-northstar';
import {
  endCallContainerStyle,
  endCallTitleStyle,
  buttonStyle,
  mainStackTokens,
  buttonsStackTokens,
  upperStackTokens,
  videoCameraIconStyle,
} from './styles/EndCall.styles';
import { ButtonstConstants } from '../core/constants';
import { IsCandidateMode } from '../Utils/Utils';
export interface EndCallProps {
  message: string;
  rejoinHandler(): void;
}

export default (props: EndCallProps): JSX.Element => {
    const rejoinCall = ButtonstConstants.RejoinCallButtonText;
    return (
        <Stack verticalAlign="center" tokens={mainStackTokens} className={endCallContainerStyle}>
            <Stack tokens={upperStackTokens}>
                <div className={endCallTitleStyle}>{props.message}</div>
                {!IsCandidateMode() && (
                    <Stack horizontal tokens={buttonsStackTokens}>
                        <PrimaryButton className={buttonStyle} onClick={props.rejoinHandler}>
                            <VideoCameraEmphasisIcon className={videoCameraIconStyle} size="medium" />
                            {rejoinCall}
                        </PrimaryButton>
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
};
